import { render, staticRenderFns } from "./thousandQuestion.vue?vue&type=template&id=28ab1f29&scoped=true"
import script from "./thousandQuestion.vue?vue&type=script&lang=ts"
export * from "./thousandQuestion.vue?vue&type=script&lang=ts"
import style0 from "./thousandQuestion.vue?vue&type=style&index=0&id=28ab1f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab1f29",
  null
  
)

export default component.exports